/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Draft_NoteInputs */

const en_us2_coaching_draft_note = /** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing changes for the student until you approve.`)
};

const pt_br2_coaching_draft_note = /** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda para o aluno até você aprovar.`)
};

const pt_pt2_coaching_draft_note = /** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda para o aluno até você aprovar.`)
};

/** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */
const es_419_coaching_draft_note = en_us2_coaching_draft_note;

/** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */
const fr_fr2_coaching_draft_note = en_us2_coaching_draft_note;

/** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */
const de_de2_coaching_draft_note = en_us2_coaching_draft_note;

/** @type {(inputs: Coaching_Draft_NoteInputs) => LocalizedString} */
const it_it2_coaching_draft_note = en_us2_coaching_draft_note;

/**
* | output |
* | --- |
* | "Nothing changes for the student until you approve." |
*
* @param {Coaching_Draft_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_draft_note = /** @type {((inputs?: Coaching_Draft_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Draft_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_draft_note(inputs)
	if (locale === "es-419") return es_419_coaching_draft_note(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_draft_note(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_draft_note(inputs)
	if (locale === "de-DE") return de_de2_coaching_draft_note(inputs)
	if (locale === "it-IT") return it_it2_coaching_draft_note(inputs)
	return en_us2_coaching_draft_note(inputs)
});
export { coaching_draft_note as "coaching.draft_note" }